import { Component, EventEmitter, OnInit, Output, ViewChildren, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FilterCheckboxConfiguration } from '@app-model/company';
import { FilterOptions, SideFilterConfiguration, SideFilterTitlesEnum } from '@app-model/filter';
import { Question } from '@app-model/questions';
import { FilterService } from '@app-services/filter.service';
import { ProofsService } from '@app-services/proofs.service';
import { QuestionsService } from '@app-services/questions.service';
import { CheckedOption, CheckedOptionUtils, TypeCheckOption } from '@app-shared/utils';
import { clearCheckedOptionRecursive } from '@app-services/filter-company.service';
import { Subscription } from 'rxjs';
import { filter, map, mergeMap } from 'rxjs/operators';
import { CheckboxMatComponent } from '../checkbox-mat/checkbox-mat.component';
import { CheckboxStoreComponent } from '../checkbox-store/checkbox-store.component';


@Component({
    selector: 'app-large-side-filter',
    templateUrl: './large-side-filter.component.html',
    styleUrls: ['./large-side-filter.component.scss'],
    standalone: false
})
export class LargeSideFilterComponent implements OnInit {
	@Output() applyFilter = new EventEmitter();
	filterReady = false;
	filter;
	sideFilterConfiguration: FilterCheckboxConfiguration[] = [];
	checkUtils: CheckedOptionUtils = new CheckedOptionUtils();


	@ViewChildren(CheckboxStoreComponent)
	checks: CheckboxStoreComponent[];

	@ViewChildren(CheckboxMatComponent)
	matChecks: CheckboxMatComponent[];

	private _unsubscribeSearchQuestions: Subscription = null;

	// /////
	filterOptions: FilterOptions = {
		pageControl: null
	};

	constructor(
		private questionsService: QuestionsService,
		private filterService: FilterService,
		private proofsService: ProofsService,
		private readonly route: ActivatedRoute
	) {}

	ngOnInit(): void {
		const {params, queryParams, data} = this.route.snapshot;

		this.filterService.initFilterPane();

		this.filterService.filterPaneElements
			.pipe(filter(result => result !== null))
			.pipe(
				mergeMap(result => {
					return this.filterService.dontRenderFilter.pipe(
						map(dontRender => {
							this.sideFilterConfiguration = SideFilterConfiguration.filter(conf => {
								return !dontRender.includes(conf.title);
							});
							return result;
						})
					);
				})
			)
			.subscribe(([filter, options]) => {
				this.filter = filter;
				this.filterReady = true;
				if (Array.isArray(options)) {
					let filter = this.sideFilterConfiguration.find(s => s.title == SideFilterTitlesEnum.SUB_AREAS);
					if (filter) {
						this.filter[filter.attrFilter] = options;
						this.updateQuestions(options);
					}
				}
			});
	}

	closeModal() {
		this.filterService.changeToogleSidePanelFilterSource(false);
	}

	submit() {
		this.checks.forEach(check => {
			let a = check.getData();
			this.filter[a.sideFilter] = a.data;
		});

		this.matChecks.forEach(check => {
			let a = check.getData();
			this.filter[a.sideFilter] = a.data;
		});

		this.filterService.onChangesFilter(this.filter);
		this.closeModal();
	}

	getFilter(attr: string): CheckedOption[] {
		return this.filter[attr];
	}

	selectEvt(evt: CheckedOption[], sideFilter: FilterCheckboxConfiguration) {
		if (sideFilter.title == SideFilterTitlesEnum.SUB_AREAS) {
			this.updateQuestions(evt);
		}
	}

	hasOptions(sideFilter: FilterCheckboxConfiguration) {
		let options = this.getFilter(sideFilter.attrFilter);

		return options ? options.length > 0 : false;
	}

	cleanFilter(sideFilter: FilterCheckboxConfiguration) {
		let options = this.getFilter(sideFilter.attrFilter);
		clearCheckedOptionRecursive(options, false);
	}

	updateQuestions(subAreasOptions: CheckedOption[]) {
		if (this._unsubscribeSearchQuestions) {
			this._unsubscribeSearchQuestions.unsubscribe();
			this._unsubscribeSearchQuestions = null;
		}
	}

	openFilterModal() {
		this.filterService.changeToogleSidePanelFilterSource(true, []);
	}

	createCheckedOptionsQuestions(questions: Question[]) {
		let filterQuestions = this.sideFilterConfiguration.find(s => s.title == SideFilterTitlesEnum.SUB_AREAS_QUESTIONS);

		const currentQuestions = this.filter[filterQuestions.attrFilter];

		if (currentQuestions.length > 0) {
			questions.forEach(q => {
				const option = currentQuestions.find(cq => cq.option.id === q.id);
				q.checked = option.checked;
			});
		}

		this.filter[filterQuestions.attrFilter] = this.checkUtils.createCheckBoxOptions(questions);
	}
	noCompanyChecked(nodes) {
		let contChecked = 0;

		nodes.forEach(node => {
			if (node.checked) {
				contChecked++;
			}
		});
		this.filter.companies.forEach(c => {
			if (c.checked) {
				contChecked++;
			}
			c.children.forEach(children => {
				if (children.checked) {
					contChecked++;
				}
			});
		});
		return contChecked == 0 ? true : false;
	}

	onChangeCheckbox(node) {
		setTimeout(() => {
			let nodes = Array.isArray(node) ? node : [node];
			const type = nodes[0].type;
			if (type === TypeCheckOption.COMPANY) {
				if (this.noCompanyChecked(nodes)) {
					this.filter.companies.forEach(c => {
						c.checked = false;
						c.children.forEach(children => {
							children.checked = false;
						});
					});
				} else {
					nodes.forEach(node => {
						this.filter.companies.forEach(c => {
							if (c.companyId === node.companyId) {
								c.checked = node.checked;
							} else {
								c.children.forEach(children => {
									if (children.companyId === node.companyId) {
										children.checked = node.checked;
									}
								});
							}
						});
					});
				}

				let uniqueCompany = false;
				let companyIdNode = null;

				if (!Array.isArray(node) && node.checked) {
					uniqueCompany = true;
					companyIdNode = node.companyId;
				}
				this.filterService.excludeFieldsFilterByCompany(this.filter.companies, uniqueCompany, companyIdNode);
			}
		}, 0);
	}

	selectAllOptions(sideFilter) {
		let options = this.getFilter(sideFilter.attrFilter);
		clearCheckedOptionRecursive(options, true);
		this.onChangeCheckbox(options);
	}
}
